import { render, staticRenderFns } from "./loading.mpx?vue&type=template&id=35f145da&scoped=true&component=true&componentId=loadingd8a157b0"
import script from "./loading.mpx?vue&type=script&lang=js&component=true&componentId=loadingd8a157b0"
export * from "./loading.mpx?vue&type=script&lang=js&component=true&componentId=loadingd8a157b0"
import style0 from "./loading.mpx?vue&type=style&index=0&id=35f145da&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22md8a157b0%22%7D&component=true&componentId=loadingd8a157b0"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f145da",
  null
  
)

export default component.exports